import { IAppState } from '../../../common/state';
import { isSuburban, offerTypeFromJsonQuery } from '../../../utils/category';

const availableMetroScheme: number[] = require('@cian/metro/ready');

export function hasMetroSelector(state: IAppState): boolean {
  const { currentLocation } = state.filters;

  return (
    currentLocation === 'moscow_mo' ||
    currentLocation === 'spb_lo' ||
    availableMetroScheme.some(id => id === currentLocation.id)
  );
}

export function hasDistrictsSelector(state: IAppState): boolean {
  const { currentLocation } = state.filters;

  return currentLocation === 'moscow_mo' || currentLocation === 'spb_lo' || currentLocation.hasDistricts;
}

export function hasHighwaysSelector(state: IAppState): boolean {
  const { currentLocation, jsonQuery } = state.filters;

  if (currentLocation === 'spb_lo') {
    return false;
  }

  return (
    (currentLocation === 'moscow_mo' || currentLocation.hasHighway) && isSuburban(offerTypeFromJsonQuery(jsonQuery))
  );
}
